import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-function-change-requests',
  templateUrl: './function-change-requests.component.html',
  styleUrls: ['./function-change-requests.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FunctionChangeRequestsComponent {}
